import FormBuilderProperty from "./FormBuilderProperty"
import { UseFormReturn } from "react-hook-form"
import { Property } from "@/gen"

export interface FormBuilderProps {
  properties?: Property[]
  form: UseFormReturn<any, any, undefined>
  deleteable?: boolean
  node_type?: string

  action_id?: string
  operation_id?: string
}

function FormBuilder(props: FormBuilderProps) {
  return (
    <div className="flex flex-col gap-4">
      {props.properties?.map((property, index) => <FormBuilderProperty {...props} property={property} key={(property as any).id} />)}
    </div>
  )
}

export default FormBuilder
